import {
    getServerSidePropsWithCollection,
    V3CollectionPublicPageLayoutContainer
} from "../../../../pagelayouts/collection-details/CollectionDetailsPublicPageLayoutContainer";

export default function CollectionSmartShareStandalonePublicPage() {
    return (
        <V3CollectionPublicPageLayoutContainer
            isStandaloneCollectionView
            useProfileSmartShareEndpoint={true}
            useCollectionSmartShareEndpoint={true}
        />
    );
}

export const getServerSideProps = getServerSidePropsWithCollection(true, false);
